// extracted by mini-css-extract-plugin
export default {"root":"errorDetails__root__D6WDS","cell":"errorDetails__cell__s1uWV","icon":"errorDetails__icon__oW0_E","title":"errorDetails__title__WvX_k","text":"errorDetails__text__bd3HX"};